import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export const useNoRebateProgramsTranslations = () => {
  const { t } = useTranslation();

  return useMemo(
    () => ({
      title: t("web_rebateprograms_emptystate_noprograms_title", {
        defaultValue: "Become a Master IB",
      }),
      description: t("web_rebateprograms_emptystate_noprograms_description", {
        defaultValue:
          "Recruit Sub IBs and earn volume-based rebates from the clients they bring",
      }),
      action: t("web_rebateprograms_emptystate_noprograms_action", {
        defaultValue: "New rebate program",
      }),
    }),
    [t],
  );
};
